import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Container } from "reactstrap";
import { defaultNgiErrorMethod, successMessage, warnMessage } from "components/Common/responses/message";
import NGITable from "components/Common/NGITable";
import { isEmpty } from "lodash";
import useStoreFilters from "customHooks/useStoreFilters";
import { AUTH_USER, FILTER_PAGE } from "utils/constants";
import { boxListColumns } from "./BoxListColumns";
import BoxSearch from "./BoxSearch";
import { deleteMTContainer, fetchMTShippingContainers } from "utils/api";
import { TYPE } from "../constants";
import ConfirmationModal from "components/Common/modals/ConfirmationModal";

const BoxesList = () => {
  const [isLoading, setLoader] = useState(false);
  const [list, setList] = useState([]);
  const { filters, setFilters } = useStoreFilters(FILTER_PAGE.MT_BOXES);
  const [currentContainer, setCurrentContainer] = useState(null);

  useEffect(() => {
    !isEmpty(filters) ? handleSearch(filters) : handleSearch();
  }, []);

  const onListLoaded = useCallback(res => {
    const {
      result: { items },
    } = res?.data;
    if (items?.length === 0) {
      warnMessage("Boxes were not found");
    }
    setList(res?.data || null);
    setLoader(false);
  }, []);

  const handleSearch = (filterOptions = {}) => {
    setLoader(true);
    const filters = { ...filterOptions };
    setFilters(filters);
    fetchMTShippingContainers(TYPE.BOXES, { depot: AUTH_USER()?.depotName, ...filters })
      .then(res => onListLoaded(res))
      .catch(err => {
        setLoader(false);
        setList(null);
        defaultNgiErrorMethod(err);
      });
  };

  const onDelete = useCallback(() => {
    closeDeleteModal();
    setLoader(true);
    deleteMTContainer(currentContainer)
      .then(() => {
        setTimeout(() => {
          setLoader(false);
          successMessage("Box deleted successfully");
          handleSearch();
        }, 3000);
      })
      .catch(e => {
        setLoader(false);
        defaultNgiErrorMethod(e);
      });
  }, [currentContainer]);

  const openDeleteModal = useCallback(id => setCurrentContainer(id), []);
  const closeDeleteModal = useCallback(() => setCurrentContainer(null), []);

  const columns = useMemo(() => boxListColumns(openDeleteModal), [openDeleteModal]);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="filters-wrapper">
            <div className="filter-buttons"></div>

            <BoxSearch handleSearch={handleSearch} />
          </div>
          <Col lg={12}>
            <NGITable
              filtersType={FILTER_PAGE.MT_BOXES}
              rowSelection={null}
              rowKey={record => record.id}
              isLoading={isLoading}
              columns={columns}
              data={list}
              updateList={handleSearch}
            />
          </Col>
          {currentContainer && (
            <ConfirmationModal
              onCancel={closeDeleteModal}
              onConfirm={onDelete}
              description="Are you sure you want to delete the box?"
            />
          )}
        </Container>
      </div>
    </>
  );
};

export default BoxesList;
